import { SuppliesShippingConditionStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import GitBranchIcon from "@redotech/redo-icons/git-branch-01.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from "../steps";
import { toSuppliesCondition } from "../steps/supplies/supplies-shipping-step-values";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";
import { suppliesShippingConditionSummary } from "./supplies-shipping-condition-summary";

export interface SuppliesShippingConditionNodeData {
  step: PartialWithRequiredType<SuppliesShippingConditionStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const SuppliesShippingConditionNode = memo(
  function SuppliesShippingConditionNode({
    id,
    data,
    selected,
  }: {
    id: string;
    data: SuppliesShippingConditionNodeData;
    selected?: boolean | undefined;
  }) {
    const { t } = useTranslation();
    const summary = useMemo(
      () =>
        suppliesShippingConditionSummary(
          toSuppliesCondition(data.step.condition),
        ),
      [data.step.condition],
    );

    return (
      <BaseNode
        icon={<RedoFeaturedIcon color="gray" Icon={GitBranchIcon} size="sm" />}
        onDelete={data.readonly ? undefined : () => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title={t("Condition")}
      >
        <Handle id="top" position={Position.Top} type="target" />
        <Flex className={NodeCSS.fullWidth} dir="column" gap="xs">
          {summary ? (
            <Text fontSize="xs">{summary}</Text>
          ) : (
            <Text className={NodeCSS.placeholderText}>
              {t("No condition set")}
            </Text>
          )}
        </Flex>
        <Handle id="bottom" position={Position.Bottom} type="source" />
      </BaseNode>
    );
  },
);
